// import SA from "scroll-animations-js";
//import AOS from 'aos';
//import {gsap} from "gsap";
//import {ScrollTrigger} from "gsap/ScrollTrigger";
// import LocomotiveScroll from "locomotive-scroll";
// import "owl.carousel";
// import axios from "axios";
// const locomotiveScroll = new LocomotiveScroll();

//SA.init({});

import jQuery from "jquery";

jQuery(".open-menu-extended").click(function () {
    jQuery(this).toggleClass("act");
    jQuery(".menu-extended").slideToggle();

    return false;
});

jQuery(".menu-extended .nav-menu-cursos>li>a").click(function () {
    if (window.innerWidth < 768) {
        jQuery(this).toggleClass("act");
        jQuery(".sub-menu", jQuery(this).parent()).slideToggle();
        return false;
    }
});

// Função para adicionar ou remover a classe 'top' no body
window.onscroll = function () {
    var body = document.body;

    // Se o usuário estiver no topo da página (scrollY == 0), adicionar a classe 'top'
    if (window.scrollY === 0) {
        body.classList.add("top");
    } else {
        body.classList.remove("top");
    }
};

// Ao carregar a página, verifica se está no topo e adiciona a classe 'top' se for o caso
window.onload = function () {
    if (window.scrollY === 0) {
        document.body.classList.add("top");
    }
};

// Filtro de Cursos

// Filtro de Cursos
document.addEventListener("DOMContentLoaded", function () {
    const botoes = document.querySelectorAll(".btn-profissao");
    const select = document.getElementById("select-curso");
    const selectMobile = document.getElementById("select-profissao-mobile");

    if (typeof site_url === "undefined") {
        console.warn("site_url não definido nesta página.");
        return;
    }

    const currentSlug = site_url.current_slug || null;
    const currentId = site_url.current_id || null;
    const currentUrl = window.location.href;

    function carregarCursos(slug, currentId = null, redirect = false) {
        fetch(site_url.ajax_url, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body:
                "action=carregar_cursos" +
                "&slug=" +
                slug +
                "&current_id=" +
                currentId,
        })
            .then((response) => response.text())
            .then((data) => {
                select.innerHTML =
                    '<option value="">Escolha o curso</option>' + data;

                if (redirect) {
                    const primeiroCurso = select.querySelector(
                        'option[value]:not([value=""])'
                    );

                    if (!primeiroCurso) return;

                    const destino = primeiroCurso.value;

                    // Evita redirecionar se já estiver na mesma página
                    if (destino !== currentUrl) {
                        window.location.href = destino;
                    }
                }
            })
            .catch((err) => console.error("Erro ao carregar cursos:", err));
    }

    // Carrega automaticamente os cursos da categoria atual (sem redirecionar)
    if (currentSlug) {
        carregarCursos(currentSlug, currentId, false);
    }

    // Clique nos botões de profissão (desktop)
    botoes.forEach((botao) => {
        botao.addEventListener("click", function () {
            botoes.forEach((b) => b.classList.remove("ativo"));
            this.classList.add("ativo");

            const slug = this.getAttribute("data-slug");
            carregarCursos(slug, null, true);
        });
    });

    // Select de profissão (mobile)
    if (selectMobile) {
        selectMobile.addEventListener("change", function () {
            const slug = this.value;
            if (!slug) return;

            document
                .querySelector(`.btn-profissao[data-slug="${slug}"]`)
                ?.click();
        });
    }

    // Redirecionar manualmente ao selecionar um curso
    select.addEventListener("change", function () {
        if (this.value && this.value !== currentUrl) {
            window.location.href = this.value;
        }
    });
});

// Comparador de Cursos

document.addEventListener("DOMContentLoaded", function () {
    const btn = document.getElementById("btnComparar");
    const gridPrincipal = document.getElementById("comparador-grid");
    const grid = document.getElementById("comparador-cursos");
    const selects = [
        document.getElementById("cursoSelect1"),
        document.getElementById("cursoSelect2"),
        document.getElementById("cursoSelect3"),
    ];

    // 🔹 flag para evitar chamadas duplicadas
    let comparando = false;

    async function montarComparador() {
        if (comparando) return; // evita duplicação
        comparando = true;

        // limpa colunas anteriores
        grid.querySelectorAll(".coluna-curso").forEach((col) => col.remove());

        // percorre selects em ordem e monta colunas
        for (const select of selects) {
            const cursoID = select.value.trim();
            if (!cursoID) continue;

            try {
                const response = await fetch(site_url.ajax_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body:
                        "action=carregar_curso_comparador&curso_id=" + cursoID,
                });

                if (!response.ok) continue;

                const html = await response.text();

                // evita duplicação de coluna (caso AJAX duplique por lag)
                if (!grid.querySelector(`[data-curso='${cursoID}']`)) {
                    const coluna = document.createElement("div");
                    coluna.innerHTML = html;
                    const div = coluna.firstElementChild;
                    div.setAttribute("data-curso", cursoID);
                    grid.appendChild(div);
                }
            } catch (err) {
                console.error("Erro ao carregar curso:", err);
            }
        }

        // ajusta alturas após inserir tudo
        if (typeof equalizeComparadorHeights === "function") {
            equalizeComparadorHeights();
        }

        comparando = false; // libera nova comparação

        // inicializar slider
        initSlider();
    }
    if (btn !== null)
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            gridPrincipal.style.display = "grid";
            montarComparador();
        });
});

function equalizeComparadorHeights() {
    const campos = [
        "nome",
        "duracao-media",
        "descricao",
        "salario-medio",
        "perspectivas-futuras",
        "possiveis-ambientes",
        "periodo",
        "referencia-da-area",
    ];

    campos.forEach((campo) => {
        // pega todos os elementos com o mesmo data-campo
        const items = document.querySelectorAll(`[data-campo="${campo}"]`);
        if (!items.length) return;

        // zera altura antes de recalcular (importante em resize)
        items.forEach((el) => (el.style.height = "auto"));

        // pega a maior altura
        const maxHeight = Math.max(
            ...Array.from(items).map((el) => el.offsetHeight)
        );

        // aplica a mesma altura a todos
        items.forEach((el) => (el.style.height = `${maxHeight}px`));
    });
}

// executa ao carregar
document.addEventListener("DOMContentLoaded", () => {
    equalizeComparadorHeights();
});

// reexecuta ao redimensionar a tela (responsivo)
window.addEventListener("resize", () => {
    equalizeComparadorHeights();
});

// Slider Comparador de Cursos

function initSlider() {
    const container = document.getElementById("comparador-cursos");
    const containerControls = document.getElementById("comparador-controls");
    const slides = container.querySelectorAll(".coluna-curso");
    const dotsContainer = document.getElementById("dots");
    const prev = document.getElementById("btnPrevComparador");
    const next = document.getElementById("btnNextComparador");

    if (!slides || slides.length === 0) return; // nada a exibir

    // limpar dots antigos
    dotsContainer.innerHTML = "";

    let index = 0;
    const total = slides.length;

    // criar dots dinamicamente
    slides.forEach((_, i) => {
        const dot = document.createElement("div");
        dot.classList.add("dot");
        if (i === 0) dot.classList.add("active");

        dot.addEventListener("click", () => goToSlide(i));

        dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll(".dot");

    function updateDots() {
        dots.forEach((d, i) => {
            d.classList.toggle("active", i === index);
        });
    }

    function goToSlide(i) {
        const width = container.clientWidth;
        index = Math.max(0, Math.min(i, total - 1));

        container.scrollTo({
            left: width * index,
            behavior: "smooth",
        });

        updateDots();
    }

    prev.onclick = () => goToSlide(index - 1);
    next.onclick = () => goToSlide(index + 1);

    // sincronizar dots com scroll manual
    container.addEventListener("scroll", () => {
        const width = container.clientWidth;
        const newIndex = Math.round(container.scrollLeft / width);

        if (newIndex !== index) {
            index = newIndex;
            updateDots();
        }
    });

    containerControls.style.display = "flex";
}

// Menu Profissões
jQuery(document).ready(function () {
    // Esconde todos os sub-menus inicialmente
    jQuery("#menu-menu-principal > .menu-item:has(.sub-menu)").find(".sub-menu").hide();

    // Aplica hover apenas nos itens que têm sub-menu
    jQuery("#menu-menu-principal .menu-item:has(.sub-menu)").hover(
        function () {
            jQuery(this).find(".sub-menu").stop(true, true).slideDown();
        },
        function () {
            jQuery(this).find(".sub-menu").stop(true, true).slideUp();
        }
    );
});